<div class="py-2 flex col-md-12">
  <div class="border rounded-md bg-[#F8F9FA] w-full">
    <div class="gradient-header move-left text-primary-500 w-32">{{'service_groups' | translate }}</div>
    <div class="container-fluid">
      <div class="row py-3">
        <div class="col-md-2" *ngFor="let group of (servicesGroup$ | async); let i = index">
          <div class="mx-2">
            <span class="mr-1">{{ i + 1 }}.</span><span class="font-semibold">{{group?.groupType}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>